// キャリア決済、PayPay決済のコイン購入処理をまとめたカスタムフック
import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { accessIdAtom, accessTokenAtom, payStartUrlAtom } from '@!/atoms/paymentAtom'
import { purchaseCoinWithCarrierApi, purchaseCoinWithPaypayApi } from '@!/Api/coinPurchase'

export const useCoinPurchase = () => {
  const navigate = useNavigate()
  const [accessId, setAccessId] = useAtom(accessIdAtom)
  const [accessToken, setAccessToken] = useAtom(accessTokenAtom)
  const [payStartUrl, setPayStartUrl] = useAtom(payStartUrlAtom)

  // キャリア決済
  const purchaseWithCarrier = useMutation({
    mutationFn: (params) => purchaseCoinWithCarrierApi(params),
    onSuccess: (data) => {
      setAccessId(data.access_id)
      setAccessToken(data.token)
      setPayStartUrl(data.start_url)
    },
  })

  // PayPay決済
  const purchaseWithPaypay = useMutation({
    mutationFn: (params) => purchaseCoinWithPaypayApi(params),
    onSuccess: (data) => {
      setAccessId(data.access_id)
      setAccessToken(data.token)
      setPayStartUrl(data.start_url)
    },
  })

  const executePurchase = (payType, listIndex, apiTime) => {
    if (payType === 'paypay') {
      purchaseWithPaypay.mutate({ listIndex, apiTime })
    } else {
      purchaseWithCarrier.mutate({ listIndex, apiTime, carrier: payType })
    }
  }

  useEffect(() => {
    if (
      purchaseWithCarrier.isPending ||
      purchaseWithPaypay.isPending ||
      purchaseWithCarrier.isError ||
      purchaseWithPaypay.isError ||
      !accessId ||
      !accessToken ||
      !payStartUrl
    ) {
      return
    }

    // GMO決済画面へリダイレクト
    navigate('/redirect')
  }, [
    accessId,
    accessToken,
    payStartUrl,
    purchaseWithCarrier.isPending,
    purchaseWithCarrier.isError,
    purchaseWithPaypay.isPending,
    purchaseWithPaypay.isError,
    navigate,
  ])

  return {
    executePurchase,
    isPurchasing: purchaseWithCarrier.isPending || purchaseWithPaypay.isPending,
    isPurchaseError: purchaseWithCarrier.isError || purchaseWithPaypay.isError,
  }
}
